import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Layout from 'sushiweb/Layout';
import ZImage from 'sushiweb/ZImage';
import PhotoViewer from 'sushiweb/PhotoViewer';
import '../../../../UiKit/imageViewer/imageViewer.scss';
import { Label } from '../../../../UiKit';
import { useEffect } from 'react';

export const PickerImageViewer = ({
  images = [],
  updateActiveIndex,
  activeIndex,
}) => {
  const [ind, setInd] = useState(0);
  const [isOpen, toggleOpen] = useState(false);

  useEffect(() => {
    const handleNext = (e) => {
      if (e.code === 'ArrowRight') {
        const goToNextImg = (prevState) => {
          if (prevState + 1 < images.length) return prevState + 1;
          else return 0;
        };
        setInd(goToNextImg);
        updateActiveIndex(goToNextImg);
      }
      if (e.code === 'ArrowLeft') {
        const goToPrevImg = (prevState) => {
          if (prevState - 1 >= 0) return prevState - 1;
          else return images.length - 1;
        };
        setInd(goToPrevImg);
        updateActiveIndex(goToPrevImg);
      }
    };
    document.addEventListener('keyup', handleNext);
    return function cleanupListener() {
      window.removeEventListener('keyup', handleNext);
    };
  }, [images.length, updateActiveIndex]);

  useEffect(() => {
    setInd(activeIndex);
  }, [activeIndex]);
  const handleClose = () => toggleOpen(false);

  const handleClick = (index) => {
    setInd(index);
    updateActiveIndex(index);
  };

  const handleActiveClick = () => {
    toggleOpen(true);
  };
  return (
    <div
      className='imageViewer'
      css={`
        width: 100%;
      `}
      data-dd-privacy='hidden'
    >
      <ZImage
        key={ind}
        src={images?.[ind]?.src}
        width='100%'
        height='300px'
        style={{ borderRadius: '6px', cursor: 'pointer' }}
        onClick={() => {
          handleActiveClick(ind);
        }}
        alt='Sample image'
        imgAlt='Sample image'
      ></ZImage>
      <Layout gap={10}>
        {images?.map((image, index) => {
          return (
            <Layout.Item colD={1} colT={3} colM={12} key={index}>
              <ZImage
                src={image?.src}
                width='100%'
                height='50px'
                style={{
                  borderRadius: '6px',
                  cursor: 'pointer',
                  padding: '5px',
                }}
                onClick={() => {
                  handleClick(index);
                }}
                alt='Sample image'
                imgAlt='Sample image'
              />
              {image?.label ? (
                <span className='label'>
                  <Label
                    title={image.label}
                    bgColor='#256FEF'
                    showIcon={false}
                    fontSize={10}
                  />
                </span>
              ) : null}
            </Layout.Item>
          );
        })}
      </Layout>
      {ReactDOM.createPortal(
        <div
          css={`
            z-index: 10000;
            position: absolute;
          `}
        >
          <PhotoViewer
            isOpen={isOpen}
            handleClose={handleClose}
            data={images}
            currentIndex={ind}
            FooterNumbers={0}
          />
        </div>,
        document.body,
      )}
    </div>
  );
};
